module.exports = __webpack_public_path__ + "static/media/Artboard19.c1da702d.png";